/**
 * Homepage banner carousel.
 *
 * Moved verbatim from the inline <script> that lived in
 * resources/views/partials/banner.blade.php.
 *
 * The markup contract (IDs used by this script):
 *   #carouselExampleControls  — the carousel container
 *   .carousel-item            — each slide
 *   #carousel-next            — next-slide control
 *   #carousel-prev            — prev-slide control
 *
 * Phase 35.5 Win D (2026-05-15) — init deferred via requestIdleCallback.
 * The <script> tag already carries `defer` (see partials/banner.blade.php
 * line 84), so download is non-blocking. This further pushes EXECUTION
 * past the browser's initial paint + LCP window — the browser only runs
 * init when it has idle main-thread time, falling back to a setTimeout
 * after 2000ms if idle never comes (e.g. heavy AdSense scripts hogging
 * the main thread).
 *
 * Trade-off: the autoplay setInterval starts up to ~2000ms later than
 * before. The first auto-advance still fires 5000ms AFTER init (not
 * after page load), so user-visible behaviour is "first slide change
 * arrives ~7000ms after page load on heavy pages, ~5000ms on light
 * pages." This is invisible in practice — users rarely watch the
 * carousel that early in the session.
 *
 * Click handlers on #carousel-prev / #carousel-next register at the
 * same time as init. If a user clicks within the first ~100ms of page
 * load (extremely rare on a 5-slide hero carousel), the click is a no-op.
 */
(function () {
    function initCarousel() {
        var carousel = document.getElementById('carouselExampleControls');
        if (!carousel) return;
        var items = carousel.querySelectorAll('.dlz-carousel-item');
        var total = items.length;
        if (total < 2) return;

        var currentIndex = 0;
        var isAnimating = false;

        function goTo(newIndex, direction) {
            if (isAnimating) return;
            isAnimating = true;
            var current = items[currentIndex];
            var next = items[newIndex];
            var enterClass = direction === 'next' ? 'dlz-carousel-item-next' : 'dlz-carousel-item-prev';
            var leaveClass = direction === 'next' ? 'dlz-carousel-item-start' : 'dlz-carousel-item-end';
            next.classList.add(enterClass);
            next.offsetWidth; // force reflow to trigger CSS transition
            current.classList.add(leaveClass);
            next.classList.add(leaveClass);
            function onTransitionEnd() {
                current.removeEventListener('transitionend', onTransitionEnd);
                current.classList.remove('dlz-active', leaveClass);
                next.classList.remove(enterClass, leaveClass);
                next.classList.add('dlz-active');
                currentIndex = newIndex;
                isAnimating = false;
            }
            current.addEventListener('transitionend', onTransitionEnd);
            // Safety: if CSS transition is suppressed (prefers-reduced-motion, hidden element),
            // transitionend may never fire — prevent carousel from freezing
            setTimeout(function () { if (isAnimating) onTransitionEnd(); }, 1000);
        }

        function nextSlide() { goTo((currentIndex + 1) % total, 'next'); }
        function prevSlide() { goTo((currentIndex - 1 + total) % total, 'prev'); }

        var autoPlay = setInterval(nextSlide, 5000);

        document.getElementById('carousel-next').addEventListener('click', function (e) {
            e.preventDefault();
            clearInterval(autoPlay);
            nextSlide();
            autoPlay = setInterval(nextSlide, 5000);
        });
        document.getElementById('carousel-prev').addEventListener('click', function (e) {
            e.preventDefault();
            clearInterval(autoPlay);
            prevSlide();
            autoPlay = setInterval(nextSlide, 5000);
        });
    }

    // Phase 35.5 Win D — defer init past initial paint via requestIdleCallback.
    // Fallback to setTimeout for Safari < 16.4 (no requestIdleCallback support).
    if ('requestIdleCallback' in window) {
        requestIdleCallback(initCarousel, { timeout: 2000 });
    } else {
        setTimeout(initCarousel, 100);
    }
})();
